import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useSound } from '../contexts/SoundContext';
import PageLayout from '../components/PageLayout';
import { FIVEFIVE_MAPS } from '../data/5v5Maps';

const FiveFiveMapsPage = () => {
  const { t } = useLanguage();
  const { playButtonClick } = useSound();
  const location = useLocation();
  const assetBase = typeof window !== 'undefined' ? window.location.origin : '';

  useEffect(() => {
    document.title = `5V5 Deathmatch Maps - ${t('app.title')}`;
  }, [t, location]);

  return (
    <PageLayout title="5V5 Deathmatch" subtitle="Select a map to explore">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mt-4">
        {FIVEFIVE_MAPS.map((map) => (
          <Link
            key={map.slug}
            to={`/maps/5v5/${map.slug}`}
            onClick={playButtonClick}
            className="group flex flex-col rounded-xl overflow-hidden border border-gray-200 dark:border-[#2A2A2A] bg-white dark:bg-[#1A1A1A] hover:border-indigo-400 dark:hover:border-[#FF8A65] hover:shadow-lg transition-all duration-200"
          >
            <div className="aspect-video overflow-hidden bg-gray-100 dark:bg-[#111]">
              <img
                src={`${assetBase}/Maps/5V5/${encodeURIComponent(map.file)}`}
                alt={map.name}
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <div className="px-3 py-2">
              <p className="text-sm font-medium text-gray-800 dark:text-gray-100 truncate">
                {map.name}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </PageLayout>
  );
};

export default FiveFiveMapsPage;
